document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.quantity-input-wrapper');

    wrappers.forEach((wrapper) => {
        const input = wrapper.querySelector('.quantity-input');
        const minusBtn = wrapper.querySelector('.minus-btn');
        const plusBtn = wrapper.querySelector('.plus-btn');

        const min = parseInt(input.getAttribute('min'));
        const max = parseInt(input.getAttribute('max'));

        function updateValue(newValue) {
            newValue = Math.max(min, Math.min(max, newValue));
            input.value = newValue;
        }

        minusBtn.addEventListener('click', () => {
            updateValue(parseInt(input.value) - 1);
        });

        plusBtn.addEventListener('click', () => {
            updateValue(parseInt(input.value) + 1);
        });

        input.addEventListener('change', () => {
            updateValue(parseInt(input.value));
        });
    });
});
